import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase configuration missing. Please check your environment variables.')
  console.warn('Required: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  db: {
    schema: 'public'
  }
})

// Helper function for handling Supabase errors
export const handleSupabaseError = (error) => {
  if (error?.message?.includes('JWT expired')) {
    return 'Session expired. Please sign in again.'
  } else if (error?.message?.includes('Row Level Security')) {
    return 'You do not have permission to perform this action.'
  } else if (error?.message?.includes('duplicate key')) {
    return 'This record already exists.'
  } else if (error?.message?.includes('Failed to fetch')) {
    return 'Cannot connect to database. Your Supabase project may be paused or inactive. Please check your Supabase dashboard and resume your project if needed.'
  } else {
    return error?.message || 'An unexpected error occurred.'
  }
}

// Type definitions for better development experience
export const TABLES = {
  USER_PROFILES: 'user_profiles',
  LEGAL_AREAS: 'legal_areas', 
  LEGAL_INQUIRIES: 'legal_inquiries',
  LAWYER_APPLICATIONS: 'lawyer_applications',
  EMAIL_NOTIFICATIONS: 'email_notifications'
}

export const USER_ROLES = {
  ADMIN: 'admin',
  LAWYER: 'lawyer', 
  CLIENT: 'client'
}

export const URGENCY_LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
}

export const APPLICATION_STATUS = {
  PENDING: 'pending',
  REVIEWING: 'reviewing',
  APPROVED: 'approved',
  REJECTED: 'rejected'
}

export const INQUIRY_STATUS = {
  NEW: 'new',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed'
}